import React, { useState } from 'react'
import cx from 'classnames'
import PageHeader from './PageHeader'
import { capitalize } from 'libraries/lodash'
import url from 'front-end-core/core/url'
import { SEARCH, MW_LIST_DEALS } from 'constants/controllers'
import connect from 'components/shared/connect'
import { SearchHistory } from 'services/SessionService'
import Grid from '@material-ui/core/Grid'
import Truncate from 'react-truncate'
import TealToolTip from 'components/TealToolTip'
import { useSelector } from 'react-redux'
import selectFlavour from 'redux/selectors/selectFlavour'
import selectAolName from 'redux/selectors/selectAolName'

const TYPE_NAMES = {
  ca: 'News',
  leg: 'Legislation',
  qa: 'Q&A',
  precedents: 'Precedents',
  markets: 'Markets'
}

const TYPE_URL = {
  qa: SEARCH,
  leg: SEARCH,
  ca: SEARCH,
  precedents: SEARCH,
  markets: MW_LIST_DEALS
}

const TYPE_SEARCH = {
  qa: 'qa',
  leg: 'legislation',
  precedents: 'precedents',
  ca: 'ca',
  markets: 'markets'
}

const History = ({ history, className }) => {
  const aol = useSelector(selectAolName)

  return (
    <div className={cx(className, 'flex flex-column f5 lighter')}>
      <PageHeader title='My searches' />
      {history.map((item, index) => <HistoryItem key={index} {...{ index, aol, ...item }} />)}
    </div>
  )
}
const HistoryItem = ({ index, date, time, type, term: searchPhrase, aol }) => {
  const flavour = useSelector(selectFlavour)
  const path = type === 'markets' && 'listdeals/all'
  const params = { flavour, path, searchType: TYPE_SEARCH[type], searchPhrase, aol }
  const href = url(TYPE_URL[type], params, { q: searchPhrase })

  const [clamped, setClamped] = useState()

  return (
    <TealToolTip title={clamped ? searchPhrase : ''} placement='left'>
      <a
        className={cx('black no-underline pa6', { 'bg-white': index % 2 === 0 })}
        href={href}
        data-event-category='Account'
        data-event-action='Search History'
        data-event-label={`[${type}] ${searchPhrase}`}
        data-help-item='accountsearchhistory'
        data-help-position='bottom'
      >
        <Grid container>
          <Grid item xs={6}>
            <Truncate
              trimWhitespace
              width={192}
              onTruncate={(isClamped) => setClamped(isClamped)}
            >
              {searchPhrase}
            </Truncate>
          </Grid>
          <Grid item xs={3}>
            <div className='tl'>{TYPE_NAMES[type] || type} {flavour && capitalize(flavour)}</div>
          </Grid>
          <Grid item xs={3}>
            <div className='w-100 tr'>{date} {time}</div>
          </Grid>
        </Grid>
      </a>
    </TealToolTip>
  )
}

export default connect(SearchHistory)(History)
